module.exports = __webpack_public_path__ + "static/media/home-advisor.aec24d00.png";